import deps from "../depsloader";

export default () => {
  deps.load("swiper").then((swiper) => {
    const Swiper = swiper.Swiper;

    let thumb = null;
    const thumbsSwiper = document.querySelector(".swiper-thumbs");
    if (thumbsSwiper) {
      let config = {};

      if (thumbsSwiper.dataset.config) {
        config = JSON.parse(thumbsSwiper.dataset.config);
        thumbsSwiper.removeAttribute("data-config");
      }

      thumb = new Swiper(thumbsSwiper, config);
    }

    const elms = document.querySelectorAll(".swiper-container:not(.swiper-thumbs)");
    elms.forEach((elm) => {
      let config = {};

      if (elm.dataset.config) {
        config = JSON.parse(elm.dataset.config);
        elm.removeAttribute("data-config");
      }

      if (thumb) {
        config = {...config, ...{thumbs: {
          swiper: thumb
        }}};

        thumb = null;
      }

      new Swiper(elm, config);
    });
  });
}
